/**
 * Introducción de una sola vez.
 *
 * Sin esto, el primer arranque muestra «Siguiente: Baseline» sin ningún
 * contexto. Se marca como visto y no vuelve a aparecer; desde Ajustes se puede
 * volver a ver.
 *
 * Cuatro ideas, ni una más: qué es, cómo funcionan los días, por qué el
 * baseline va primero, y qué significan las tres duraciones.
 */

import { useState } from 'react';

import { ajustesRepo } from '../../persistencia/ajustesRepo';
import estilos from './Onboarding.module.css';

interface Tarjeta {
  titulo: string;
  cuerpo: string[];
}

const TARJETAS: Tarjeta[] = [
  {
    titulo: 'Tu centro de operaciones',
    cuerpo: [
      'Un programa de 12 semanas para hablar inglés espontáneo: sin guion, con mejor listening y acceso más rápido a las palabras.',
      'Todo el plan vive acá dentro. No vas a tener que recordar ningún documento externo.',
    ],
  },
  {
    titulo: 'Los días son sesiones, no fechas',
    cuerpo: [
      'El Día 1, el Día 2 y los demás son sesiones secuenciales. No son lunes, martes ni miércoles.',
      'Si un día no entrenás, no hay deuda ni penalización: seguís por la siguiente sesión pendiente.',
    ],
  },
  {
    titulo: 'El baseline va primero',
    cuerpo: [
      'Antes del Día 1 hacés una medición. Sirve para descubrir tus dificultades principales reales y no entrenar problemas imaginarios.',
      'Lo que salga ahí decide cuánto peso tendrán listening, pronunciación, recuperación léxica y conversación.',
    ],
  },
  {
    titulo: '20, 35 o 50 minutos',
    cuerpo: [
      'Cada sesión existe en tres versiones. Elegís según el tiempo que tengas.',
      'El día define QUÉ entrenás. El tiempo disponible solo define CUÁNTO profundizás: el objetivo de la sesión no cambia porque tengas menos tiempo.',
    ],
  },
];

export function Onboarding() {
  const [indice, setIndice] = useState(0);
  const tarjeta = TARJETAS[indice]!;
  const esUltima = indice === TARJETAS.length - 1;

  return (
    <div className={estilos.fondo} role="dialog" aria-modal="true" aria-labelledby="onb-titulo">
      <div className={estilos.tarjeta}>
        <p className={estilos.paso}>
          {indice + 1} de {TARJETAS.length}
        </p>
        <h1 className={estilos.titulo} id="onb-titulo">
          {tarjeta.titulo}
        </h1>
        {tarjeta.cuerpo.map((parrafo) => (
          <p key={parrafo} className={estilos.parrafo}>
            {parrafo}
          </p>
        ))}

        <div className={estilos.acciones}>
          {indice > 0 ? (
            <button
              type="button"
              className={estilos.secundario}
              onClick={() => setIndice(indice - 1)}
            >
              Atrás
            </button>
          ) : (
            <button
              type="button"
              className={estilos.secundario}
              onClick={() => void ajustesRepo.marcarOnboardingVisto()}
            >
              Saltar
            </button>
          )}

          {esUltima ? (
            <button
              type="button"
              className={estilos.principal}
              onClick={() => void ajustesRepo.marcarOnboardingVisto()}
            >
              Empezar
            </button>
          ) : (
            <button
              type="button"
              className={estilos.principal}
              onClick={() => setIndice(indice + 1)}
            >
              Siguiente
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
